import {AbstractEvent} from "@/modules/base/events";

export class AfterCreateGameEvent extends AbstractEvent {
}
